import { Account, PostingClass } from '../interfaces/accounting.interface';

/** Display names where plain "humanise the enum" reads badly ("Gr ir clearing"). */
export const POSTING_CLASS_LABELS: Record<PostingClass, string> = {
    BALANCE_SHEET: 'Balance sheet',
    RECEIVABLE: 'Receivable',
    PAYABLE: 'Payable',
    CASH: 'Cash',
    TAX: 'Tax',
    EXPENSE: 'Expense',
    REVENUE: 'Revenue',
    INVENTORY: 'Inventory',
    GR_IR_CLEARING: 'GR/IR clearing',
    INTER_SEGMENT_CLEARING: 'Inter-segment clearing',
    INTER_SEGMENT_RECEIVABLE: 'Inter-segment due-from',
    INTER_SEGMENT_PAYABLE: 'Inter-segment due-to',
};

export const postingClassLabel = (pc?: PostingClass | string | null): string =>
    pc ? (POSTING_CLASS_LABELS[pc as PostingClass] ?? pc) : '—';

/**
 * The posting class a NEW account starts with: its parent's, when the parent has one; otherwise from the account type
 * (ASSET / LIABILITY / EQUITY are balance-sheet accounts, REVENUE and EXPENSE take the matching P&L class).
 * A starting point only: the user can still change it in the dialog.
 */
export function defaultPostingClass(
    accountType: Account['accountType'],
    parent?: Pick<Account, 'postingClass'> | null,
): PostingClass {
    if (parent?.postingClass) return parent.postingClass;
    if (accountType === 'REVENUE') return 'REVENUE';
    if (accountType === 'EXPENSE') return 'EXPENSE';
    return 'BALANCE_SHEET';
}
